<template>
  <v-dialog v-model="valueProxy" width="90%" max-width="1000px">
    <ProductSelector
      ref="productSelector"
      :categories="categories"
      :selectedProducts="selectedProducts"
    >
      <template #title-right>
        <v-btn icon @click="valueProxy = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </ProductSelector>
  </v-dialog>
</template>

<script>
import editDialogMixin from '@/services/editDialogMixin';
import ProductSelector from '@/components/PhysicalProduct/ProductSelector.vue';

export default {
  name: 'ProductCategoryList',
  components: { ProductSelector },
  mixins: [editDialogMixin],
  props: {
    categories: [],
    selectedProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    remove(item) {
      this.$refs.productSelector.remove(item);
    },
    editItemQty(item, qty) {
      this.$refs.productSelector.editItemQty(item, qty);
    },
  },
};
</script>

<style lang="scss"></style>
